module.exports = __webpack_public_path__ + "res/ic_landscape_s.e599c7f7b684b7531e58f5d7954f3b90.png";